// getters
const cafeteriaRequests = state => state.cafeteriaRequests

export default {
  cafeteriaRequests
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/requests/getters.js